module.exports = __webpack_public_path__ + "img/5-4.8d3aea12.svg";